if (!customElements.get('ffn-story-carousel')) {
  customElements.define('ffn-story-carousel', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.ffn-story-slide')];
      if (!this.slides.length) return;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = false;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
        this.show(this.index + Number(button.dataset.direction), this.paused);
        this.schedule();
      }, options));
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.show(0, true);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.schedule();
    }
    show(index, immediate = false) {
      const nextIndex = (index + this.slides.length) % this.slides.length;
      const activeSlide = this.slides[nextIndex];
      clearTimeout(this.transitionTimer);
      const commit = () => {
        this.index = nextIndex;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', String(i !== this.index));
        });
        this.dataset.world = activeSlide.dataset.world || 'sportline';
        const caption = this.querySelector('.ffn-story-caption');
        if (caption) caption.textContent = activeSlide.dataset.caption || '';
        const count = this.querySelector('.ffn-story-count');
        if (count) count.textContent = `0${nextIndex + 1} / 03`;
        if (!immediate) requestAnimationFrame(() => this.classList.remove('is-transitioning'));
      };
      if (immediate) commit();
      else {
        this.classList.add('is-transitioning');
        this.transitionTimer = setTimeout(commit, 220);
      }
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.transitionTimer);
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
